import React from 'react';
import { Building2, Target } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const features = [
    {
      icon: Building2,
      title: language === 'tr' ? 'Kuruluş' : 'Established',
      value: '2000'
    },
    {
      icon: Target,
      title: language === 'tr' ? 'Hizmet Alanı' : 'Service Areas',
      value: '6'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.about.title}
          </h1>
        </div>

        {/* Stats */}
        <div className="flex justify-center gap-16 md:gap-32 mb-20">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <feature.icon className="text-blue-700" size={32} />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{feature.value}</div>
              <div className="text-gray-600">{feature.title}</div>
            </div>
          ))}
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto space-y-12">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              {language === 'tr' ? 'Hikayemiz' : 'Our Story'}
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">{t.about.story}</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              {language === 'tr' ? 'Misyonumuz' : 'Our Mission'}
            </h2>
            <p className="text-gray-600 leading-relaxed">{t.about.mission}</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              {language === 'tr' ? 'Değerlerimiz' : 'Our Values'}
            </h2>
            <p className="text-gray-600 leading-relaxed">{t.about.values}</p>
          </div>

          {/* Image */}
          <div className="rounded-xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1651525670114-2b8117390b28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxmYWN0b3J5JTIwcHJvZHVjdGlvbnxlbnwwfHx8fDE3Njk3NzkzODV8MA&ixlib=rb-4.1.0&q=85"
              alt="NanoGen Factory"
              className="w-full h-96 object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
